import React, { useContext } from 'react';

import styled from '@emotion/styled';

import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ViewComplaintModalProps {
  data: any;
}

const ViewComplaintModal: React.FC<ViewComplaintModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);

  const onClose = () => {
    modalContext?.setShowModal(!modalContext?.showModal);
  };

  return (
    <ModalContainer label='View Complaint'>
      <Container>
        <Item>
          <ItemLabel>Reason for Rejection</ItemLabel>
          <ItemValue>{data?.rejectionReason ?? 'N/A'}</ItemValue>
        </Item>

        <Item>
          <ItemLabel>Customer Complaint</ItemLabel>
          <ItemValue>{data?.complaint ?? 'N/A'}</ItemValue>
        </Item>
        <CloseButton onClick={onClose}>Close</CloseButton>
      </Container>
    </ModalContainer>
  );
};

export default ViewComplaintModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding: 16px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ItemLabel = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #4b5563;
`;

const ItemValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  background: #f5f5f5;
  border-radius: 4px;
  padding: 10px 16px;
`;

const CloseButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  background: white;
  cursor: pointer;
`;
